import React from 'react';
import { SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import Scroll from 'react-scroll'; // Imports all Mixins
import { Col, Grid, Row } from 'react-bootstrap';
import Form from './Form';
import { withRouter } from 'react-router';
import { resetPassword } from '../../actions/login';
import './styles.css';

class ForgottenPassword extends React.Component<{}> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const scroll = Scroll.animateScroll;
    scroll.scrollToTop({ duration: 0 });
  }

  componentDidUpdate(nextProps) {
    if (this.props.reset.resetSuccess) {
      this.props.history.push('/login');
    }
  }

  handleSubmit = val => {
    return this.props
      .resetPassword(this.props.match.params.id, {
        password: val.passwordTwo,
        activkey: this.props.match.params.key
      })
      .then(res => {
        if (this.props.reset.hasFailed) {
          throw new SubmissionError({ _error: this.props.reset.errorMessage[0].message });
        }
      });
  };

  render() {
    //console.log(this.props.reset);
    return (
      <div className="forgotten">
        <Grid>
          <Row>
            <Col xs={12}>
              <h2>Change Password</h2>
              <br />
              <h5>
                Fields with <span style={{ color: 'red' }}>*</span> are required
              </h5>
              <Row>
                <Form onSubmit={r => this.handleSubmit(r)} />
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(connect(state => ({ reset: state.login.reset }), { resetPassword })(ForgottenPassword));



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordPage/index.js